export default __webpack_public_path__ + "static/about1-bbc55f3d5aabeb8887388050663ec916.jpg";